module.exports = __webpack_public_path__ + "img/add_place_button.d307079e.svg";